// extracted by mini-css-extract-plugin
export var dropdown = "_ot-1";
export var hidden = "_ot-0";